var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/HTMLBaseContainer.ts
import { Float } from "@adornis/baseql/baseqlTypes.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { HTMLBase } from "./HTMLBase.js";
var HTMLBaseContainer = class extends HTMLBase {
  getBackgroundColorParsed() {
    return this.backgroundColorRgba(this.backgroundColor ?? "", this.opacity ?? 0);
  }
  backgroundColorRgba(background, opacity) {
    if (!background)
      return "";
    const rgb = this._hexToRgb(background);
    if (!rgb)
      return "";
    const result = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity || 1})`;
    return result;
  }
  _hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }
};
HTMLBaseContainer._class = "HTMLBaseContainer";
__decorateClass([
  Field((type) => String)
], HTMLBaseContainer.prototype, "borderRadius", 2);
__decorateClass([
  Field((type) => String)
], HTMLBaseContainer.prototype, "backgroundColor", 2);
__decorateClass([
  Field((type) => Float)
], HTMLBaseContainer.prototype, "opacity", 2);
__decorateClass([
  Field((type) => String)
], HTMLBaseContainer.prototype, "height", 2);
HTMLBaseContainer = __decorateClass([
  Entity()
], HTMLBaseContainer);
export {
  HTMLBaseContainer
};
